import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Benefits } from "@/components/Benefits";
import { History } from "@/components/History";
import { Process } from "@/components/Process";
import { Eligibility } from "@/components/Eligibility";
import { Calculator } from "@/components/Calculator";
import { About } from "@/components/About";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { TaxGuideSection } from "@/components/TaxGuideSection";
import { StickyCTA } from "@/components/StickyCTA";
import { Toaster } from "@/components/ui/sonner";
import { SecureRetirement } from "@/pages/SecureRetirement";
import { ThankYou } from "@/pages/ThankYou";
import { NotFound } from "@/pages/NotFound";
import { GetQuote } from "@/pages/GetQuote";
import { Schedule } from "@/pages/Schedule";

// Main landing page component
const MainPage = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Benefits />
      <Process />
      <Eligibility />
      <Calculator />
      <About />
      <History />
      <TaxGuideSection />
      <FAQ />
      <Contact />
    </main>
    <Footer />
    <StickyCTA />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/secureretirement" element={<SecureRetirement />} />
          <Route path="/get-quote" element={<GetQuote />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
